<template>

  <ion-page id="puzzle-history-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
          :style="styleHistory">

        <!-- <div v-show="showTour">
          <Tour  :tour="tourInfo" :tourTrigger="tourTrigger" @tour-done="tourDone" />
        </div> -->

        <ion-item>
          <ion-label color="secondary" class="ion-text-center">
            <h2>{{ displayTitle }}</h2>
          </ion-label>
        </ion-item>

        <div v-for="item in historyItems" v-bind:key="item.index">
          <div :id="item.id" @click="onPuzzleClick(item.index)" class="history-center-text">
            {{ item.date }} {{ item.category }}
            <span v-if="item.success=='y'"><ion-icon aria-hidden="true" :icon="thumbsUp" /></span>
            <br>
            Rating={{ item.rating }} {{ item.special }}             
          </div>
        </div>
      </div>
      <ActionSheet :heading="actionHeadingString" :items="actionSheetButtons" 
                  :trigger="actionSheetTrigger"
                  @action-sheet-result="actionSheetResult">
      </ActionSheet>
    </ion-content>
    <Toolbar id="the_toolbar" :elements="toolbarElements" :trigger="toolbarTrigger"
                          :ignoreClicks="showTour" @toolbar-click="toolbarClick" />
  </ion-page>

</template>

<script setup>

  import { IonItem, IonLabel, IonIcon,IonPage, IonContent , modalController } from '@ionic/vue';
  import { thumbsUp, thumbsDown, star } from 'ionicons/icons';

  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import ModalGenericSingleList from '@/components/ModalGenericSingleList.vue'
  import ModalGenericMultiList from '@/components/ModalGenericMultiList.vue'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
  import ActionSheet from '@/components/ActionSheet.vue'

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'
  import { ref, watch, onMounted, onUpdated, nextTick } from 'vue'
  import Toolbar from '@/components/Toolbar.vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData , useGetDataDownload } from '@/composables/getData.js'
  import { useStringStore } from '@/stores/stringStore';
  import Tour from '@/components/Tour.vue'
  import { t , replaceMultipleAll } from '@/composables/translateText.js'

   import { findPuzzleCategoryByName } from '@/composables/puzzleSupport';

  const props = defineProps({
    isReturn : {
      type : Boolean,
      default : false
    }
  })

  const emit = defineEmits(['next-item-click'])

  const windowSizeStore = useWindowSizeStore()
  const noAvailableMovesFlag = ref(0)
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const connectionStore = useConnectionStore()
  const isDark = ref(connectionStore.getDarkmode != "light")

  const stringStore = useStringStore()

  var displayTitle = ""

   const serverTranslations = [
        [ "~puzzle_cat_all~", t("All")],
        [ "~server_graph_title_puzzles~", t("Puzzles")],
        [ "~universal_time_string~", t("Time")],
        [ "~server_history_half_move~", t("Visualize half move")],
        [ "~server_history_one_move~", t("Visualize 1 move")],
        ["~server_graph_seconds~", t("Secs") ],
        [ "~server_moves~", t("Moves")],
        [ "~server_graph_lifetime~", t("Lifetime")],
        [ "~server_graph_visualized_string~", t("Visualized")]
      ]

  // start option stuff

  var timePeriodSelected = []
  var timePeriodTitle = ""

  var speedsSelected = []
  var speedsTitle = ""

  var puzzleTypeSelected = []
  var puzzleTypeTitle = ""

  var backupSelected = []
  var backupTitle = ""

  var optionDisplayArray = []
  var optionDisplaySelected = ""
  var optionHeading = ""
  var optionAction = ""

  // which option is being worked on in generic list
  var whichOptionIsGenericList = ""

  // end option stuff

  const actionHeadingString = ref(t("Options"))
  const menuTrigger = ref(0)

  const tourTrigger = ref(0)
  const tourOption = connectionStore.getTourOption
  //console.log("*** Tour option",tourOption)
  const showTour = ref((tourOption == "show"))

  const TOOLBAR_DOWNLOAD = 0
  const TOOLBAR_OPTIONS = 1

  const toolbarElements = ref([
    { index : TOOLBAR_DOWNLOAD, label : t("Download") , disabled : false, collapse:false},
    { index : TOOLBAR_OPTIONS, label : t("Options") ,disabled : false, hasAction : true }
  ])
  const toolbarTrigger = ref(0)

  const ACTION_OPTION_PERIOD = 0
  const ACTION_OPTION_TYPE = 1
  const ACTION_OPTION_SPEED = 2
  const ACTION_OPTION_VISUALIZE = 3
 
  // OPTIONS Action sheet.  First two are for everyone, then append as needed
  const actionSheetTrigger = ref(0)
  var actionSheetButtons = [
      { text: t("Time Period"), data: { index: ACTION_OPTION_PERIOD } },
      { text: t("Puzzle Type"), data: { index : ACTION_OPTION_TYPE } },
      { text: t("Timed Speed"), data: { index : ACTION_OPTION_SPEED } },
      { text: t("Visualize Moves"), data: { index : ACTION_OPTION_VISUALIZE } },
      { text: t('Cancel'), role: 'cancel',data: { index : -1} }

    ]

  const timePeriodDisplay = [ t("Last") + " 7 " + t("days"), t("Last") + " 30 " + t("days") , t("Last") + " 6 " + t("months"), t("All")]
  const timePeriodValue = [ "168" , "720", "4368", "65000"]

  const puzzleTypeDisplay = [ t("Regular"), t("Visualize"), t("Timed"), t("All")]
  const puzzleTypeValue = [ "r", "v","t", "all"]

  const secs = t("Secs")
  const speedsDisplay = [ "5 " + secs, "10 " + secs, "15 " + secs,"20 " + secs,"30 " + secs,"45 " + secs,"240 " + secs, t("All") ]
  const speedsValue = [ "5", "10", "15", "20", "30", "45", "240", "all"]

  const moveString = t("Move")
  const movesString = t("Moves")

  const backupDisplay = [ t("1 Half move (1 ply)"),  "1 " + moveString , "2 " + movesString, "4 " + movesString,"5 " + movesString,"10 " + movesString, t("All")]
  const backupValue = [ "1", "2", "4", "8", "10", "20", "all" ]

  const styleHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const historyItems = ref([])

// tour stuff
const tourInfo = ref({
 id : "game_history",
 video : "",
 elements : [
   { id: "", title: "Game History", text : "A scrollable list of the last 99 games you've played against the computer or blindfold.<br><br>Clicking on a game takes you to the 'Review' screen."},
   { id: "the_toolbar", title: "Download - Toolbar", text : "Builds a PGN file of all the games you've played. You can import this into another game review program"}
 ]
})

doStartupCheck(false,afterStartupCallbackRoutine)

// onMounted(() => {
//   const show_element = document.getElementById('id40');
//   console.log("show element",show_element)
//   show_element.scrollIntoView({ behavior: "smooth" })
//    })

const openErrorModal = async (programName,errorMessage) => {
 const modal = await modalController.create({
   component: ModalErrorMessage,
   componentProps: {
     type : "commError",
     program : programName ,
     errorMessage : errorMessage
   }
 });

 modal.present();

 const { data, role } = await modal.onWillDismiss();
};

function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
 if (errorProgram != null)
   openErrorModal(errorProgram,errorEntry)
 updateWidthHeights()
 getHistory("initial","")
 menuTrigger.value++
}

watch(() => windowSizeStore.getWindowSize, () => {
 windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                   height : windowSizeStore.getWindowSize['height'] }
 updateWidthHeights()
})

function updateStyleObjects(boundaries) {
 styleHistory.value.height = boundaries['history'].height + "px"
 styleHistory.value.width = boundaries['history'].width + "px"
 styleHistory.value.top = boundaries['history'].top + "px"
 styleHistory.value.left = boundaries['history'].left + "px"

}

function updateWidthHeights() {
 const availableSpace = availableWidthHeight()
 const boundaries = calculateWidthHeights(availableSpace)
 
 updateStyleObjects(boundaries)
}


function calculateWidthHeights(availableSpace) {

 const historyPositionTop = 0
 const historyPositionLeft = availableSpace.leftRightIndent
 const historyHeight = availableSpace.height - historyPositionTop
 const historyWidth = availableSpace.width - availableSpace.leftRightIndent * 2

 const result = { 
   history : {
     width : historyWidth,
     height : historyHeight,
     left : historyPositionLeft + availableSpace.leftIndent,
     top : historyPositionTop+ availableSpace.topIndent
   }
 }
 return (result)
}

 // stuff for options

  // Start ACTION LIST
  function actionSheetResult(action,index) {
    if (action != "yes")
      return
    //console.log("*** ACTION SHEET INDEX ",index)
    actionClick(index)
  }

  function actionClick(index) {
    var displays = []
    var values = []
    var initials= []
    switch (index) {
      case ACTION_OPTION_PERIOD :
        displays = timePeriodDisplay
        values = timePeriodValue
        initials = timePeriodSelected
        optionHeading = timePeriodTitle
        optionDisplaySelected = timePeriodSelected[0]
        optionAction = "when"
        break
      case ACTION_OPTION_TYPE :
        displays = puzzleTypeDisplay
        values = puzzleTypeValue
        initials = puzzleTypeSelected
        optionHeading = puzzleTypeTitle
        optionAction = "puzzle"
        break
      case ACTION_OPTION_SPEED :
        displays = speedsDisplay
        values = speedsValue
        initials = speedsSelected
        optionHeading = speedsTitle
        optionAction = "speed"
        break
      case ACTION_OPTION_VISUALIZE :
        displays = backupDisplay
        values = backupValue
        initials = backupSelected
        optionHeading = backupTitle
        optionAction = "backup"
        break
    }

    optionDisplayArray = []
    for (var i=0; i < displays.length; i++) {
      var isSelected = false
      for (var j=0; j < initials.length; j++)
        if (initials[j] == values[i]) {
          isSelected = true
          break
        }
      const oneItem = { 
        index : i,
        selected : isSelected,
        name : displays[i],
        id : values[i],
        radio : "" + values[i]
      }
      optionDisplayArray.push(oneItem)
    }
    if (index == ACTION_OPTION_PERIOD)
      openGenericSingleListModal()
    else
      openGenericMultiListModal()

  }

  // END Action List

  // START Generic Options List

  const openGenericSingleListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericSingleList,
      componentProps: {
        displayArray : optionDisplayArray,
        initialValue : optionDisplaySelected,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //console.log("SINGLE CONFIRM in static",data)
      getHistory(optionAction,data.selected)
   }
  };

  const openGenericMultiListModal = async () => {
    const modal = await modalController.create({
      component: ModalGenericMultiList,
      componentProps: {
        displayArray : optionDisplayArray,
        title : optionHeading      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      //console.log("CONFIRM in static",data)
      getHistory(optionAction,data)
   }
  };
  // END Generic Options List

function toolbarClick(index) {
    switch (index) {
      case TOOLBAR_OPTIONS :
        //console.log("Click on Options")
        actionSheetTrigger.value++
        break
      case TOOLBAR_DOWNLOAD :
        getDownload()
        break
    }
}

function onPuzzleClick(index) {
  const onePuzzle = historyItems.value[index]
  //console.log("in history click ",onePuzzle)
  connectionStore.setPuzzleHistoryId(onePuzzle.puzzleId)
  connectionStore.setPuzzleHistoryRating(onePuzzle.rating)
  connectionStore.setPuzzleHistoryReturnIndex(index)
  emit("next-item-click","puzzle_from_history",t("Puzzle From History"),"puzzle")

}

  

function tourDone() {
    showTour.value = false
}

function processJsonResponse (json) {
    //console.log(" in puzzle history callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    displayTitle = replaceMultipleAll(json["title"],serverTranslations)

    // get the option strings
    timePeriodSelected = json["time_period_selected"].split(",")
    timePeriodTitle = t("Select Time Period")

    speedsSelected = json["speeds_selected"].split(",")
    speedsTitle = t("For Timed Puzzles, Select Speed(s)")

    const puzzle_type_json = json["puzzle_type_selected"]
    puzzleTypeSelected = puzzle_type_json.split(",")
    puzzleTypeTitle = t("Select Puzzle Type(s)")

    backupSelected = json["backup_selected"].split(",")
    backupTitle = t("For Visualized Puzzles, Select # of Moves")

    var puzzleCount = Math.floor(json["count"])

    const dates = json["date"].split(",")
    const categories = json["cat"].split("\t")
    const successes = json["outcome"].split(",")
    const ratings = json["rating"].split(",")

    const specialString = json["special"]
    const specialExpanded = specialString

    const specials = specialExpanded.split(",")
    const puzzleIds = json["id"].split(",")

    for (var i=0; i < puzzleCount; i++) {
      //console.log("index", i)
      //console.log("Category ",i,categories[i])
      var displayCategory = ""
      if (categories[i] == "Do Over")
         displayCategory = t("Do Over")
      else
        if (categories[i].startsWith("puzzle_cat_")) {
          const trimmedName = categories[i].substring(11)
          //console.log("trimmed name",trimmedName)
          const foundCategory = findPuzzleCategoryByName(trimmedName)
          if (foundCategory != null)
            displayCategory = foundCategory.shortname
          else
            displayCategory = categories[i]
        }
      const onePuzzle = { index : i,
              id : "id" + i,
              puzzleId : puzzleIds[i],
              date : dates[i],
              category : t(displayCategory),
              success : successes[i],
              rating : ratings[i],
              special : replaceMultipleAll(specials[i],serverTranslations)
            }
      historyItems.value.push(onePuzzle)
    }

    // coming back from showing puzzle. put that entry in the middle of the screen
    if (props.isReturn) {
      const returnIndex = connectionStore.getPuzzleHistoryReturnIndex

      nextTick().then(() => {
        // DOM is now updated
        //console.log("Continue here")
        const show_element = document.getElementById("id" + returnIndex)
        //console.log("show element",show_element)
        show_element.scrollIntoView({block: "center"})
      })
    }

  }
  
  function getHistory(what,value) {

    historyItems.value = []

    const timeNow = Math.floor(Date.now() / 1000)

    var formData = {
      what : what,
      value : value,
      time : timeNow
    }

    //console.log("formdata in get history",formData)
    useGetData("getweb_lichess_history.php", formData, processJsonResponse)
  }

  function getDownload() {
    const timeNow = Math.floor(Date.now() / 1000)

    const formData = {
      time : timeNow,
      puzzle : ""
    }

    useGetDataDownload("buildweb_puzzle_pgn.php", formData)
  }

</script>

<style scoped>

.history-center-text {
  text-align: center;
  margin-bottom : 5px;
  margin-top : 5px;
  border-bottom: slategray dotted 1px;
  /*border-bottom: #286a6c solid 1px;*/
}

.history-center-text:hover {
  background: #4c6ca0;
}

</style>